import { USE_CASE_MAP } from "@/data/useCases";

export function reviewToMarkdown(review) {
  const uc = USE_CASE_MAP[review.document_type] || { label: review.document_type };
  const dt = new Date(review.created_at || Date.now()).toLocaleString();
  const c = review.risk_counts || {};
  const lines = [];
  lines.push(`# PDF Review — ${uc.label}`);
  lines.push(`**File:** ${review.filename}`);
  lines.push(`**Reviewed:** ${dt}`);
  lines.push(
    `**Risk summary:** ${c.red || 0} red · ${c.amber || 0} amber · ${c.green || 0} green`
  );
  lines.push("");
  lines.push(`## Executive summary`);
  lines.push(review.summary || "_No summary produced._");
  lines.push("");

  if ((review.missing_clauses || []).length) {
    lines.push(`## Missing clauses`);
    for (const m of review.missing_clauses) lines.push(`- ${m}`);
    lines.push("");
  }

  lines.push(`## Findings`);
  const sortOrder = { red: 0, amber: 1, green: 2 };
  const sorted = [...(review.findings || [])].sort(
    (a, b) => (sortOrder[a.severity] ?? 3) - (sortOrder[b.severity] ?? 3)
  );
  sorted.forEach((f, i) => {
    lines.push(
      `### ${i + 1}. ${f.title}  \`${(f.severity || "amber").toUpperCase()}\`${
        f.page_number ? ` — p.${f.page_number}` : ""
      }`
    );
    if (f.quoted_snippet) {
      lines.push(`> "${f.quoted_snippet}"`);
    }
    if (f.why_it_matters) {
      lines.push(`**Why it matters:** ${f.why_it_matters}`);
    }
    if (f.recommended_action) {
      lines.push(`**Recommended action:** ${f.recommended_action}`);
    }
    lines.push("");
  });

  if (review.memo) {
    lines.push(`## Memo`);
    lines.push(review.memo);
    lines.push("");
  }

  lines.push(
    `---\n_This is document review assistance, not legal, tax, or professional advice._`
  );
  return lines.join("\n");
}

export function downloadMarkdown(review) {
  const md = reviewToMarkdown(review);
  const blob = new Blob([md], { type: "text/markdown;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  const base = (review.filename || "review").replace(/\.[^.]+$/, "");
  a.href = url;
  a.download = `${base}-review.md`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
